import { render, staticRenderFns } from "./InformList.vue?vue&type=template&id=4524e42c&scoped=true&"
import script from "./InformList.vue?vue&type=script&lang=js&"
export * from "./InformList.vue?vue&type=script&lang=js&"
import style0 from "./InformList.vue?vue&type=style&index=0&id=4524e42c&scoped=true&lang=scss&"
import style1 from "./InformList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524e42c",
  null
  
)

export default component.exports